import { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { getExits } from "../../services/newdaily";
import ExitCalendar from "../../components/ExitCalendar/ExitCalendar";
import TaskHeaderExit from "../../components/TaskHeaderExit/TaskHeaderExit";
import TaskExitCards from "../../components/TaskExitCards/TaskExitCards";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "overlayscrollbars/overlayscrollbars.css";
import styles from "./Exits.module.css";
import foldersImg from "../../assets/svgs/folders2.svg";
import { SpinnerComponent } from "../../components/Spinner";

const normalizeForCalendar = (apiData) => {
    const list = [];
    if (!apiData || typeof apiData !== "object") return list;
    Object.entries(apiData).forEach(([fecha, usersObj]) => {
        if (!usersObj || typeof usersObj !== "object") return;
        Object.keys(usersObj)
            .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }))
            .forEach((nombre) => {
                list.push({ Empleado: nombre, Fecha: fecha });
            });
    });

    return list;
};


const Exits = ({ empleado, refreshSignal, isAdmin }) => {
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
    const [exitData, setExitData] = useState([]);
    const [rawSalidas, setRawSalidas] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchSalidas = useCallback(async () => {
        try {
            setLoading(true);
            const data = await getExits();

            setRawSalidas(data || {});
            setExitData(normalizeForCalendar(data));

        } catch (e) {
            console.error("Error cargando salidas:", e);
            setRawSalidas({});
            setExitData([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSalidas();
    }, [fetchSalidas, refreshSignal]);


    const dayData = rawSalidas?.[selectedDate] || {};

    return (
        <div className={styles.exitsViewContainer}>
            <div className={styles.leftPanel}>
                <ExitCalendar
                    data={exitData}
                    isAdmin={isAdmin}
                    onDaySelect={(day) => setSelectedDate(day)}
                />
            </div>

            {loading ? (
                <div style={{ width: "36%" }}>
                    <SpinnerComponent />
                </div>
            ) : (
            <div className={styles.rightPanel}>
                <div className={styles.headerContainer}>
                    <TaskHeaderExit selectedDate={selectedDate} userName={""} />
                </div>
                <OverlayScrollbarsComponent
                    options={{
                        scrollbars: { autoHide: "scroll", autoHideDelay: 300 },
                        overflowBehavior: { x: "hidden", y: "scroll" },
                    }}
                    style={{ maxHeight: "85vh", width: "100%" }}
                >
                    <div className={styles.exitsContent}>
                        {loading ? (
                            <div className={styles.loadingInScroll}>
                                <div className={styles.spinner} />
                                <p className={styles.loadingText}>Cargando</p>
                            </div>
                        ) : Object.keys(dayData || {}).length === 0 ? (
                            <div className={styles.noExitContainer}>
                                <img src={foldersImg} alt="No exits" className={styles.noExitImage} />
                                <p className={styles.noExitText}>No hay salidas para este día</p>
                            </div>
                        ) : (
                            <TaskExitCards dayData={dayData} />
                        )}
                    </div>
                </OverlayScrollbarsComponent>
            </div>
            )}
        </div>
    );
};

export default Exits;
